import { ReactNode } from "react";
import classnames from "classnames";
import styles from "./Message.module.css";

const Message = ({ message, type }: MessageType) => {
  if (!message) {
    return null;
  }
  return (
    <div className={classnames(styles.message, styles[type])}>{message}</div>
  );
};

type MessageType = {
  message: ReactNode;
  type?: TYPE_MESSAGE | undefined;
};

enum TYPE_MESSAGE {
  info,
  success,
  error,
  warning,
}

export default Message;
